import { useMutation, UseMutationOptions } from 'react-query';

import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';
import { entityExportsApi } from 'src/Services/API';
import {
  CreateEntityExportDtoEntityTypeEnum,
  CreateEntityExportDtoRuleEnum,
  CreateEntityExportDtoTypeEnum,
  EntityExportDto,
} from 'src/Services/API/generated';
import { trackEvent } from 'src/Services/Matomo';
import { ApiError } from 'src/types/api-error.types';

export const useCreateContactRuleExport = (
  options?: UseMutationOptions<EntityExportDto, ApiError, CreateEntityExportDtoRuleEnum>
) => {
  const assetId = useCurrentAssetId();

  return useMutation<EntityExportDto, ApiError, CreateEntityExportDtoRuleEnum>(
    ['create-contact-rule-export', assetId],
    async (rule: CreateEntityExportDtoRuleEnum) => {
      if (!assetId) {
        throw new Error('No asset selected');
      }
      const dto = {
        entityType: CreateEntityExportDtoEntityTypeEnum.Contact,
        type: CreateEntityExportDtoTypeEnum.Dynamic,
        rule,
        isPublic: true,
      };

      const response = await entityExportsApi.entityExportsControllerCreate(assetId, dto);
      return response.data;
    },
    {
      ...options,
      onSuccess: (data, variables, context) => {
        trackEvent('Export', 'create', 'contact');
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
